interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

const selectFile = (options: {
  multiple?: boolean;
  accept: string;
}): Promise<FileList> => {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = options.accept;
    if (options.multiple) {
      input.multiple = options.multiple;
    }
    input.onchange = (e: HTMLInputEvent) => {
      if (e.target.files) {
        resolve(e.target.files);
        document.body.removeChild(input);
      }
    };
    input.style.display = 'none';
    document.body.appendChild(input);
    input.click();
  });
};

export default selectFile;
